import { render } from "./TheMyCollectionAppTag.vue?vue&type=template&id=fa1e3420&scoped=true&ts=true"
import script from "./TheMyCollectionAppTag.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionAppTag.vue?vue&type=script&lang=ts"

import "./TheMyCollectionAppTag.vue?vue&type=style&index=0&id=fa1e3420&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1e3420"]])

export default __exports__